<template>
  <div id="the-collection">
    <b-container class="the-collection-container">
      <Header title="The Collection" />
      <div class="cards">
        <ProductCard
          :productCardId="1"
          class="collection-card"
          :productData="{
            title: `“LEGENDS” HOODIE`,
            buyurl: 'https://www.ivyshop.com/pages/nikkowashington',
            subtitle:
              'men’s brushed fleece pullover raglan hoodie with pouch pocket',
            images: [
              require('@/assets/images/products/legends-hoodie/Legends-Hoodie-01.jpg'),
              require('@/assets/images/products/legends-hoodie/Legends-Hoodie-02.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/legends-hoodie/Legends-Hoodie-01@2x.jpg'),
              require('@/assets/images/products/legends-hoodie/Legends-Hoodie-02@2x.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">
            “LEGENDS” <br />
            HOODIE
          </h5>
          <div slot="description">
            <p>
              The silhouettes of these powerful icons speak for themselves. Show
              your respect for these Cubs legends with this understated
              statement piece.
            </p>
            <p>
              Designed in collaboration with Chicago-based artist Nikko
              Washington. Proceeds benefit The Bloc.
            </p>
          </div>
          <!-- <div slot="product-details">
            <span>Color: Navy</span><br />
            <span>Sizes: S, M, L, XL, XXL</span><br />
            <span>80% Cotton, 20% Polyester</span><br />
            <span>Printed in the USA</span>
          </div> -->
        </ProductCard>
        <ProductCard
          :productCardId="2"
          class="collection-card"
          :productData="{
            title: `“MR. CUB” CREW NECK T-SHIRT`,
            buyurl: 'https://www.ivyshop.com/pages/nikkowashington',
            subtitle: 'men’s cotton jersey short sleeve crew neck t-shirt',
            images: [
              require('@/assets/images/products/crew-neck-t/Lets-play-to-01.jpg'),
              require('@/assets/images/products/crew-neck-t/Lets-play-to-03.jpg'),
            ],
            highResImages: [
              require('@/assets/images/products/crew-neck-t/Lets-play-to-01@2x.jpg'),
              require('@/assets/images/products/crew-neck-t/Lets-play-to-03@2x.jpg'),
            ],
            productSaleInfo: {
              productAvailable: false,
              textDate: 'SOLD OUT',
            },
          }"
        >
          <h5 slot="product-title">“MR. CUB” <br />CREW NECK T-SHIRT</h5>
          <div slot="description">
            <p>
              Mr. Cub exuded confidence and grace in everything he did. Yet, his
              contributions to society far exceed his Hall of Fame career. This
              t-shirt shines a light on his ability to bring people together,
              regardless of race, for a common good.
            </p>
            <p>
              Designed in collaboration with Chicago-based artist Nikko
              Washington. Proceeds benefit The Bloc.
            </p>
          </div>
          <!-- <div slot="product-details">
            <span>Colors: Black, White</span><br />
            <span>Sizes: S, M, L, XL, XXL</span><br />
            <span>100% Cotton</span><br />
            <span>Printed in the USA</span>
          </div> -->
        </ProductCard>
      </div>
    </b-container>
  </div>
</template>

<script>
import Header from "@/components/global/Header";
import ProductCard from "@/components/global/ProductCard";

import { mapState } from "vuex";
export default {
  name: "TheCollection",
  components: {
    Header,
    ProductCard,
  },
  computed: {
    ...mapState(["global"]),
  },
};
</script>

<style lang="scss" scoped>
#the-collection {
  padding-bottom: 100px;
  @media (max-width: $lg) {
    padding-bottom: 50px;
  }
  @media (max-width: $md) {
    padding-bottom: 0px;
  }
  @media (max-width: $md) {
    padding-bottom: 50px;
  }
  .the-collection-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    @media (max-width: $lg) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
  .cards {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 50px;
    @media (max-width: $lg) {
      flex-direction: column;
      align-items: center;
    }
  }
  .collection-card {
    width: 480px;
    max-width: 49.5%;
    @media (max-width: $lg) {
      margin-bottom: 50px;
      max-width: 100%;
    }
  }

  p,
  span {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: start;
    line-height: 23px;
    @media (max-width: $lg) {
      text-align: center;
    }
  }
}
</style>
